import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CookiesPopup = () => {
  const [cookieConsent, setCookieConsent] = useState(null);
  // Load consent on mount
  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (consent) setCookieConsent(consent);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setCookieConsent("accepted");
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setCookieConsent("rejected");
  };

  const handleManage = () => {
    localStorage.setItem("cookieConsent", "managed");
    setCookieConsent("managed");
  };

  return (
    <>
      {!cookieConsent && (
        <section className=" fixed bottom-0 right-0 w-full  h-full z-50 bg-black/45">
          {/* Cookie Popup */}
          <div
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-duration="1100"
            className="absolute bottom-5 lg:bottom-14 lg:right-4 lg:w-[40%] xl:w-[35%] mx-4 md:mx-14 lg:mx-0 px-2 py-3 rounded-2xl flex flex-col gap-4 text-white -translate-x-1/2 z-30 bg-[#233D9B] bg-opacity-80 backdrop-blur-[1.5px]"
          >
            <p className="text-[12px] md:text-[14px] font-extralight leading-relaxed text-center">
              We use cookies to improve your browsing experience and analyze
              site traffic. By continuing, you agree to our{" "}
              <span className="text-[#49D093]">
                {" "}
                <Link to={"/privacy-policy"}> Privacy Policy</Link>
              </span>{" "}
              and{" "}
              <span className="text-[#49D093]">
                {" "}
                <Link to={"/cookie-policy"}> Cookie Policy.</Link>
              </span>
            </p>
            <div className=" flex flex-col md:flex-row gap-4 justify-center lg:justify-start ml-3 pb-1 text-[12px] md:text-[13px] lg:text-[12px]">
              <button
                onClick={handleAccept}
                className=" bg-gradient-to-r from-[#1842D4] via-[#143cce] to-[#0c216e53] px-4 py-3 md:px-4 md:py-1 rounded-lg hover:scale-105 transition-all duration-300"
              >
                Accept All
              </button>
              <button
                onClick={handleReject}
                className=" bg-gradient-to-r from-[#1842D4] via-[#143cce] to-[#0c216e53]  px-4 py-3 md:px-4 md:py-1 rounded-lg hover:scale-105 transition-all duration-300"
              >
                Reject Non-Essential
              </button>
              <button
                onClick={handleManage}
                className=" bg-gradient-to-r from-[#1842D4] via-[#143cce] to-[#0c216e53]  px-4 py-3 md:px-4 md:py-1 rounded-lg hover:scale-105 transition-all duration-300"
              >
                Manage Preferences{" "}
              </button>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default CookiesPopup;
